import React, { Component } from 'react'

import '../stylesheets/footer.css'
export default class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                
            <div className="footer-container" data-aos="fade-up">
            <section className="top-container">
               <a href="#" className="top"><i className="fa fa-arrow-circle-up" aria-hidden="true"></i> To the top</a> 
               </section> 
               <section className="footer-content">
                <span className="fa fa-facebook"></span>
                <span className="fa fa-twitter"></span>
                <span className="fa fa-instagram"></span>
               </section>  
       <section className="dev"><p>Developed and maintain by: <strong>InnoEve</strong></p></section>
   
      <section className="note"><p><strong>In case of any copyright issue please contact us. We will tackle it soon.Write us(innoeve4@gmail.com)</strong></p></section>
      
              </div>
            </React.Fragment>
        )
    }
}
